import React from 'react';
import './App.css';
import useAuth from './hooks/useAuth';

//Routes
import Router from './routes';

function App() {
  const { isInitialized } = useAuth();
  return (
    <div>
   {isInitialized ? <Router/> : null}
   </div>
  );
}

export default App;
